import { render, staticRenderFns } from "./base-checkbox.vue?vue&type=template&id=7e6ebc22"
import script from "./base-checkbox.vue?vue&type=script&lang=js"
export * from "./base-checkbox.vue?vue&type=script&lang=js"
import style0 from "./base-checkbox.vue?vue&type=style&index=0&id=7e6ebc22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports